import {
  VariantDetail,
  Sample,
  fetchVariantDetails,
  fetchAnalysisVariantDetails
} from '@/@core/services/app.service'
import { isJson, unique } from '@/@core/utils/utils'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CardContent,
  Stack,
  Divider,
  Tooltip,
  MenuItem,
  Tabs,
  Tab
} from '@mui/material'
import {} from 'antd'
import { Box, Grid, Chip, Card, Typography } from '@mui/material'
import { useRouter } from 'next/router'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'

interface Column {
  id: string
  label: string
  minWidth?: number
  align?: 'right' | 'left' | 'center'
  format?: (value: any) => any
}

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

function a11yProps(index: number | string) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

export const Clingen = (props: { value: any }) => {
  const router = useRouter()
  const { t, i18n } = useTranslation()

  const [tabValue, setTabValue] = React.useState(0)

  const current = React.useMemo(() => {
    return props.value
  }, [props.value])

  const scip_clinical_genome_data: any[] = React.useMemo(() => {
    return props.value.scip_clinical_genome_data ?? []
  }, [props.value])

  const scip_clingen_sv_data: any[] = React.useMemo(() => {
    return props.value.scip_clingen_sv_data
      ? props.value.scip_clingen_sv_data
      : props.value.scip_clingen_sv
      ? props.value.scip_clingen_sv
      : []
  }, [props.value])

  return (
    <Box>
      <Box width={'600px'}>
        <Stack direction={'row'} paddingLeft={4}>
          <Typography flex={1}>name</Typography>

          <Typography flex={1}> halp </Typography>

          <Typography flex={1}> trip </Typography>
        </Stack>

        <Divider />

        <Box maxHeight="300px" overflow="auto">
          {scip_clingen_sv_data?.map((item: any, index: any) => {
            return (
              <Tooltip title={`chr${item.chrom}:${item.start}-${item.end}`}>
                <React.Fragment key={`${item.transcript_id}_${index}`}>
                  <MenuItem>
                    <Stack direction={'row'} width="100%">
                      <Typography flex={1} fontSize={'12px'}>
                        {item.name}
                      </Typography>

                      <Typography flex={1} fontSize={'12px'}>
                        {item.haploinsufficiency}
                      </Typography>

                      <Typography flex={1} fontSize={'12px'}>
                        {item.triplosensitivity}
                      </Typography>
                    </Stack>
                  </MenuItem>

                  <Divider />
                </React.Fragment>
              </Tooltip>
            )
          })}
        </Box>
      </Box>

      <Box>
        <Tabs
          value={tabValue}
          onChange={(e: any, newValue) => {
            setTabValue(newValue)
          }}
          aria-label="basic tabs example"
        >
          {scip_clinical_genome_data.map((item, index) => {
            return (
              <Tab
                key={`${item.dosageId}_tab`}
                sx={{
                  textTransform: 'capitalize'
                }}
                label={t(item.dosageId ?? '')}
                {...a11yProps(index)}
              />
            )
          })}
        </Tabs>

        {scip_clinical_genome_data.map((i, index) => {
          return (
            <TabPanel
              key={`${i.dosageId}_panel`}
              value={tabValue}
              index={index}
            >
              <Box width={'800px'}>
                <Stack direction={'row'}>
                  {i.descriptionParsed &&
                  Object.keys(i.descriptionParsed).length ? (
                    <Box>
                      <Typography>{`${i.dosageId}(${i.hgncId})`}</Typography>

                      {Object.keys(i.descriptionParsed).map((key) => {
                        return (
                          <Typography>{`${key}: ${i.descriptionParsed[key]}`}</Typography>
                        )
                      })}

                      <Typography>{`detailHiScore: ${i.detailHiScore}`}</Typography>

                      <Typography>{`detailTsScore: ${i.detailTsScore}`}</Typography>
                    </Box>
                  ) : (
                    <Box>
                      <Typography>{`${i.dosageId}(${i.hgncId})`}</Typography>

                      <Typography>{`descriptionRaw: ${i.descriptionRaw}`}</Typography>

                      <Typography>{`detailHiScore: ${i.detailHiScore}`}</Typography>

                      <Typography>{`detailTsScore: ${i.detailTsScore}`}</Typography>
                    </Box>
                  )}
                </Stack>
              </Box>
            </TabPanel>
          )
        })}
      </Box>
    </Box>
  )
}
